import React from 'react';
import { Empty } from 'antd';
import { imagePath as resolveBundledImageUrl } from '@common/services/images-service';
import { Colors, FontSize, FontWeight } from '@common/tokens';

export const EmptyContent = ({
  text,
  header,
  imagePath,
  height = 200,
}: {
  text?: React.ReactNode;
  header?: string;
  /**
   * Relative path under `app/javascript/works/assets/images` (e.g. `./team/empty-team.png`).
   * Resolved at build time via the images service; this is the only supported way to supply artwork.
   */
  imagePath?: string;
  height?: number;
}) => {
  const image = imagePath ? resolveBundledImageUrl(imagePath) : undefined;

  return (
    <Empty
      image={image}
      imageStyle={{
        height,
        maxWidth: '100%',
      }}
      description={null}
    >
      <span className="empty-header">{header}</span>
      <span className="empty-content">{text}</span>
      <style jsx>{`
        .empty-header {
          display: block;
          padding: 24px 0 16px;
          font-size: ${FontSize.xl};
          font-weight: 700;
        }
        .empty-content {
          display: block;
          color: ${Colors.midnightLighter};
          font-size: ${FontSize.xl};
          font-weight: ${FontWeight.light};
        }
      `}</style>
    </Empty>
  );
};
